"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var types = _interopRequireWildcard(require("./types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    isFetchingAssigned: false,
    userAssignedPageable: {
      content: []
    },
    isFetchingStatusChanged: false,
    userStatusChangedPageable: {
      content: []
    },
    isFetchingUserEventActivity: false,
    userEventActivityPageable: {
      content: []
    }
  };
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case types.USER_ASSIGNED_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingAssigned: true
      });

    case types.USER_ASSIGNED_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingAssigned: false,
        userAssignedPageable: action.userAssignedPageable
      });

    case types.USER_ASSIGNED_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingAssigned: false
      });

    case types.USER_STATUS_CHANGED_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingStatusChanged: true
      });

    case types.USER_STATUS_CHANGED_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingStatusChanged: false,
        userStatusChangedPageable: action.userStatusChangedPageable
      });

    case types.USER_STATUS_CHANGED_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingStatusChanged: false
      });

    case types.USER_EVENT_ACTIVITY_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingUserEventActivity: true
      });

    case types.USER_EVENT_ACTIVITY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingUserEventActivity: false,
        userEventActivityPageable: action.userEventActivityPageable
      });

    case types.USER_EVENT_ACTIVITY_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingUserEventActivity: false
      });

    default:
      return state;
  }
};

exports["default"] = _default;